import { render, staticRenderFns } from "./AlternativeDashboard.vue?vue&type=template&id=6eca7c0c&"
import script from "./AlternativeDashboard.vue?vue&type=script&lang=js&"
export * from "./AlternativeDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports